import styled from 'styled-components';
import Image from '../../components/utils/Image/Image';
import { Text14Bold, Text14Regular, Text18Bold } from '../../components/utils/Text/Text.styles';

export const Container = styled.div`
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
  gap: 2.6rem;
  height: 100%;

  @media (min-width: 761px) {
    padding: 1rem 0;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.6rem;
  padding: 0;
  margin: 0 auto;

  @media (min-width: 761px) {
    max-width: 76rem;
    gap: 2.8rem;
  }
`;

export const Avatar = styled(Image)`
  width: 12rem;
  height: 12rem;
  border-radius: 50%;
  margin-bottom: 0.8rem;
  border: ${({ $isSubscribed }) => $isSubscribed && '2px solid #9680FF'};
  padding: ${({ $isSubscribed }) => $isSubscribed && '3px'};

  img {
    border-radius: 50%;
  }

  @media (min-width: 761px) {
    width: 15rem;
    height: 15rem;
    margin-bottom: 0;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (min-width: 761px) {
    gap: 0.8rem;
  }
`;

export const NameText = styled(Text18Bold)`
  @media (min-width: 761px) {
    font-size: 2.4rem;
    letter-spacing: -1px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;

  @media (min-width: 761px) {
    align-items: flex-start;
    gap: 0.4rem;
  }
`;

export const DotText = styled(Text14Regular)`
  opacity: 0.4;
`;

export const InfluencerInfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 761px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 2rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-top: 1.2rem;

  @media (min-width: 761px) {
    margin-top: 2.4rem;
  }
`;

export const MessageButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.6rem;
  cursor: pointer;
  outline: none;
  border: none;
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.2rem;
  letter-spacing: -0.43px;
  border-radius: 100px;
  background: #f8fcff;
  height: 4.2rem;
  color: #000;

  svg {
    margin-top: 0.3rem;
  }
`;

export const ShareButton = styled(MessageButton)`
  color: #fff;
  background: #000;
  width: 10rem;
  justify-content: center;
  box-shadow:
    0 0 2px 0 rgba(0, 0, 0, 0.1),
    0 1px 8px 0 rgba(0, 0, 0, 0.12);

  svg {
    margin-top: unset;
  }
`;

export const TelegramUsername = styled(Text14Bold)`
  color: #5badff;
  line-height: 2.2rem;
  letter-spacing: -0.4px;

  @media (min-width: 761px) {
    font-size: 1.6rem;
  }
`;

export const StoriesContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 0.2rem;
  padding: 0.2rem;

  @media (min-width: 761px) {
    gap: 0.4rem;
    padding: 0;
  }
`;

export const EmptyMediaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  padding: 7.8rem 2.4rem 0;
  text-align: center;
`;

export const EmptyMediaLogo = styled.img`
  display: block;
  width: 10rem;
  height: auto;
`;

export const EmptyMediaText = styled(Text14Bold)`
  color: #fff;
  font-size: 1.4rem;
  font-weight: 600;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const InfiniteScrollMarker = styled.div`
  min-width: 1rem;
  min-height: 1rem;
`;

export const StoryContainer = styled.div`
  border-radius: 1px;
  min-height: 20rem;
  height: 20rem;
  overflow: hidden;

  div {
    aspect-ratio: unset;
    height: 100%;
  }

  img,
  video {
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 761px) {
    min-height: 37rem;
    height: 37rem;
    border-radius: 2px;
  }
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 761px) {
    align-items: flex-start;
  }
`;

export const BackButton = styled.button`
  display: none;

  @media (min-width: 761px) {
    display: inline-flex;
    align-items: center;
    gap: 0.8rem;
    width: fit-content;
    padding: 0;
    border: none;
    background: transparent;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 400;
    letter-spacing: -0.075px;
    opacity: 0.5;
    cursor: pointer;

    svg {
      width: 2.4rem;
      height: 2.4rem;
      transform: rotate(180deg);
    }
  }
`;
